import React, { Suspense, useState } from 'react';
import Header from '../../Header';
import Main from '../../Main';
import Footer from '../../Footer';
import OuterWrap from '../OuterWrap';
import MainWrapper from '../../MainWrapper';
import Container from '../../Container';
import CategoryMenu from '../../CategoryMenu';
import { usePageHooks } from '../../../hooks/usePageHooks';

const Page = props => {
  const {
    children,
    layout,
    style,
    multilayer = false,
    searchIsFoldable,
  } = props;
  const [showMenu, setShowMenu] = useState(false);

  const pageClassNames = {
    ...props,
    extraClassName: showMenu ? 'catMenuOpen' : '',
  };

  usePageHooks(pageClassNames);

  return (
    <OuterWrap>
      <Suspense fallback={<div>Загрузка...</div>}>
        <Header
          layout={layout}
          onToggleMenu={setShowMenu}
          showMenu={showMenu}
          searchIsFoldable={searchIsFoldable}
        />
        <CategoryMenu showMenu={showMenu} setShowMenu={setShowMenu} />
      </Suspense>

      <Main style={style}>
        {multilayer ? (
          <MainWrapper>
            <Container>{children}</Container>
          </MainWrapper>
        ) : (
          children
        )}
      </Main>

      {layout !== 'fullscreen-layout' ? <Footer /> : null}
    </OuterWrap>
  );
};

export default Page;
